<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Offer <i class="fas fa-hashtag"></i>{{offer.offer_id}}</h4>
                    </div>

                    <offer-overview :offer="offer"></offer-overview>
                </div>
            </div>
            <div class="col-4">
                <offer-sidebar :offer="offer"></offer-sidebar>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import OfferOverview from "./sections/OfferOverview";
    import OfferSidebar from "./sections/OfferSidebar";

    export default {
        name: "ViewOffer",
        props: ["offerid"],
        components: {OfferOverview, OfferSidebar},
        data() {
            return {
                offer: {
                    offer_id: 1,
                    user_id: 2,
                    type: 'SELL',
                    category: 'FIRM',
                    status: 'ACTIVE',
                    commodity: 'Wheat',
                    description: 'Hard Red Spring Wheat is grown in North and South Dakota, Montana, Wyoming, and Idaho.',
                    commodity_props: {grade: 'A', special_quality: 'NON_GMO'},
                    harvest_year: '2019',
                    currency: 'USD',
                    pricing_type: 'CASH',
                    unit: {
                        id: 2,
                        name: 'Kilogram',
                        symbol: 'kg',
                        base_unit: 'kg'
                    },
                    quantity: '120000.000000000000000000',
                    unit_price: '2.500000000000000000',
                    created_at: '2018-12-27T03:43:46.073Z',
                    expires_at: '2018-12-15T00:00:00.000Z',
                    email: 'varma@saranya.com',
                    first_name: 'Pandu',
                    last_name: 'Varma',
                    name: 'Saranya Greenhouse',
                    line1: 'F-91, 2nd Floor',
                    line2: 'Hotel Oberoi Towers, Nariman Point',
                    city: 'Mumbai',
                    state: 'Maharashtra',
                    postal_code: '400021',
                    country: 'India'
                }
            };
        },
        beforeMount() {
            this.getOffer();
        },
        computed: {
            ...mapGetters(["currentUser"])
        },
        methods: {
            getOffer() {
                this.$http
                .get("/offers/" + this.offerid)
                .then(reply => {
                    this.offer = reply.data;
                });
            }
        }
    };
</script>

<style scoped>

</style>